//-- active feature flags

// not implemented yet
export const CSV_UPLOADER = 'csv_uploader';
export const QR_CODE_GENERATOR = 'qr_code_generator';

// sub jobs share customers with their main job
// (see HawksAccountType in accountTypeOptions)
export const SUB_JOBS = 'sub_jobs';

// as of now this only adds a GDPR checkbox to the access code page
// also prevents customers from automatically being "opted in" for promotions in CreateCustomer & QRCodeGenerator
export const GDPR = 'gdpr';

// adds the account logo to Mandrill emails
export const EMAIL_BRANDING = 'email_branding';

// mark accounts as test accounts to keep them out of reports
export const TEST_ACCOUNT = 'test_account';

// at one point push notifications could be sent via Firebase.
// not sure if this still works or is used
export const PUSH_NOTIFICATIONS = 'push_notifications';

// at one point a "hashtag" field could be set on the job,
// and customers could text this to the Twilio number to be added to it.
// not sure if this is still used but it does look like it should work.
// note that the hashtag must be globally unique,
// 2 accounts can't have the same one
export const HASHTAGS = 'hashtags';

// this gives the Glossy account (2) access to GF Crew account jobs
// and is used by the GF Crew app to store and retrieve settings
// for each account's registration page.
// it gives them an auth token that they can refresh
export const CL_EVENTS_AUTHORITY = 'cl_events_authority';

// show Club Med grids in portal (visits, rooms, guests) & use kiosk theme
export const CLUB_MED = 'club_med';

// use Ice Castle kiosk theme
export const ICE_CASTLE = 'ice_castle';

// show Hawks fields in custoemrs grid (section, row, seat)
export const HAWKS = 'hawks';

// not sure yet
export const HPX = 'hpx';

// a QR code appears in the PWA that can be scanned by the tagging app.
// the photographer also has physical QR codes that can be scanned
// by the tagging app and also by the customer to register online.
// the memory code is a string that begins with CLU_
export const MEMORY_CODES = 'memory_codes';

// tags will be parsed from images upon upload
export const IMAGE_CODES = 'image_codes';

// QR code templates can be uploaded and a QR code will be made available in the customer's gallery
// when they log in via the Access Code Page
export const QR_CODE_WORKFLOW = 'qr_code_workflow';

// show kiosks and catalogs
export const KIOSK_MODE = 'kiosk_mode';

// allow admins to log into the pre print gallery of the kiosk
export const PRE_PRINT = 'pre_print';

// enable product dropdown on catalogs
export const CATALOG_PRODUCTS = 'catalog_products';

// disable adding customers (they'll be added some other way)
export const DISABLE_ADD_CUSTOMER = 'disable_add_customer';

// Google Drive flags
export const DRIVE_UPLOAD = 'drive_upload';
export const DRIVE_EDITING = 'drive_editing';
export const DRIVE_PRINTING = 'drive_printing';
export const DRIVE_COPY = 'drive_copy';

// customers have custom default images based on their customer_metadata
export const CUSTOM_DEFAULTS = 'custom_defaults';

// will force customer creation when an email or access code has been previously used
// once the visit duration has elapsed
export const VISIT_DURATIONS = 'visit_durations';

// delay customer notifications
export const NOTIFICATION_DELAYS = 'notification_delays';

// tagging app flags
export const APP_SELECT_JOBS = 'app_select_jobs';
export const APP_SELECT_ROOMS = 'app_select_rooms';
export const APP_SELECT_PRODUCT = 'app_select_product';
export const APP_INPUT_PHONE = 'app_input_phone';
export const APP_EXPORT_TAGGED = 'app_export_tagged';
export const APP_EXPORT_ALL = 'app_export_all';
export const APP_UPLOAD_API = 'app_upload_api';
export const APP_UPLOAD_DRIVE = 'app_upload_drive';
export const APP_ENABLE_CAMERA = 'app_enable_camera';
export const APP_CODE_MULTIPLE = 'app_code_multiple';
export const APP_SCAN_NFC = 'app_scan_nfc';
export const APP_SCAN_NFC_ACCESS = 'app_scan_nfc_access';
export const APP_NFC_ACCESS_SERIAL = 'app_nfc_access_serial';
export const APP_NFC_ACCESS_NDEF = 'app_nfc_access_ndef';
export const APP_SCAN_QR_CODE_E = 'app_scan_qr_code';
export const APP_HARDWARE_HARRY = 'app_hardware_harry';
export const APP_AUTO_UPLOAD = 'app_auto_upload';
export const APP_QR_CODE_REGEX = 'app_qr_code_regex';

// enable product discount codes
export const DISCOUNT_CODES = 'discount_codes';

// enable custom pins in the kiosk
export const CUSTOM_PINS = 'custom_pins';

// disable uploading in the portal (images will be uploaded another way)
export const DISABLE_UPLOAD = 'disable_upload';

// show and manage default moments for a job (but not kiosk catalogs)
export const DEFAULT_MOMENTS = 'default_moments';

// hide access code in customer grid and modal
export const HIDE_ACCESS_CODE = 'hide_access_code';

export const DATA_RETENTION_ENABLED = 'data_retention_enabled';
export const FACIAL_REC = 'facial_rec';

//-- deprecated feature flags

// relied on an old version of the Magisto API.
// there is a video editor implemented in the old portal
const VIDEO_STORIES = 'video_stories';

// very old and no longer implemented, can be removed.
// the old web cart would open as the print store in the old app
const WEB_CART_PROOF_MODE = 'web_cart_proof_mode';

// this would set "AmountDiscountType" on a product before the marketplace
const DISCOUNT_PRICE = 'discount_price';

// this would disable refunds in the old native apps.
// it can be removed or repurposed.
// it just sets "no_refund: true" in the GET /story/:id response
const NO_REFUND = 'no_refund';

// this would toggle on the "created" field in the old portal.
// it can be removed
const SHOW_CUSTOMER_CREATED = 'show_customer_created';

// Braze (formerly AppBoy) has been disabled and is no longer being used
const BRAZE_CAMPAIGN_ENABLED = 'braze_campaign_enabled';
